import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  examCategory: {},
  examList: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalExams: 1
  },
  exam: {},
  examHistory: [],
  examScore: [],
  isLoadingScore: false,
  isLoadingHistory: false,
  isLoading: false,

  // Update
  examCombo: {},
  examDetail: {},
  examIndexList: [],
  examDataList: [],
  examAudioList: [],
  examResponse: {},
  examState: {
    skill: null,
    part: null,
    question: null
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};